import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { Yext } from 'js/components/Soy2js/Soy2js.js'; // NOTE: if not using soy2js, replace with window.Yext = window.Yext || {};
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js'; /* TODO: remove if unused */
import { LocationHours } from 'js/components/LocationHours/index.js'; /* TODO: remove if unused */
import { Maps } from 'js/components/Maps/index.js'; /* TODO: remove if unused */

import { LocationMap } from 'js/search/modules/LocationMap.js';
Yext.Maps = Maps
Yext.Maps.LocationMap = LocationMap;

Global.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
  Maps.loadAndRun();
  LocationHours.loadAndRun();

  // - The un-minified file is different than the minified one :/
  // - Uncomment the following if using JVector map
  // VectorMap.autorun();
});
